import { render, staticRenderFns } from "./CourseResults.vue?vue&type=template&id=3a750976&"
import script from "./CourseResults.vue?vue&type=script&lang=js&"
export * from "./CourseResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports